<template>
  <div v-if="showForceSD" class="force-sd-indicator">
    <span>Force SD</span>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref, onUnmounted } from 'vue'
import { useFrameDataStore } from "@/store/frameDataStore";

const frameDataStore = useFrameDataStore();
const showForceSD = ref(false);
let hideTimer: ReturnType<typeof setTimeout> | null = null;

watch(() => frameDataStore.currentData, (e: any) => {
  if (e?.vehicleData?.routing?.forceEnableSdMapMode) {
    // 检测到 Force SD 开启，立即显示
    showForceSD.value = true;
    // 清除之前的隐藏定时器
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  } else {
    // 检测到 Force SD 关闭或数据缺失，延迟3秒后隐藏
    if (showForceSD.value && !hideTimer) {
      hideTimer = setTimeout(() => {
        showForceSD.value = false;
        hideTimer = null;
      }, 3000);
    }
  }
})

onUnmounted(() => {
  if (hideTimer) {
    clearTimeout(hideTimer);
  }
})
</script>

<style lang="less" scoped>
.force-sd-indicator {
  position: fixed;
  top: 30px;
  left: 10px;
  z-index: 3001;
  height: 24px;
  line-height: 24px;
  background: rgba(255, 0, 0, 0.8);
  color: #fff;
  border-radius: 5px;
  padding: 0 10px;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
</style>
